import { UiButton } from '@/ui/UiButton'
import {
  UiCard,
  UiCardContent,
  UiCardDescription,
  UiCardHeader,
  UiCardTitle,
} from '@/ui/UiCard'

type Props = {
  isVisible: boolean
  isMember: boolean
  isSubmitting: boolean
  hasVoted: boolean
  userVoteOption?: 'YES' | 'NO'
  submitApprove: () => void
  submitReject: () => void
}

export default function VotingPanel({
  isVisible,
  isMember,
  isSubmitting,
  hasVoted,
  userVoteOption,
  submitApprove,
  submitReject,
}: Props) {
  if (!isVisible) return null

  return (
    <UiCard>
      <UiCardHeader>
        <UiCardTitle>Voting</UiCardTitle>
        <UiCardDescription>
          {hasVoted
            ? 'You have already voted on this proposal'
            : 'Submit your vote to the chain'}
        </UiCardDescription>
      </UiCardHeader>

      <UiCardContent>
        {(() => {
          if (!isMember) {
            return (
              <p className='text-muted-foreground text-sm'>
                Only multisig group members can vote on this proposal
              </p>
            )
          }

          if (hasVoted && userVoteOption) {
            return (
              <div className='space-y-3'>
                <p className='text-muted-foreground text-sm'>
                  Your vote:{' '}
                  <span className='text-foreground font-semibold'>
                    {userVoteOption === 'YES' ? 'Approve (YES)' : 'Reject (NO)'}
                  </span>
                </p>
                <div className='flex flex-col gap-3 sm:flex-row'>
                  <UiButton
                    size='lg'
                    type='button'
                    variant={userVoteOption === 'YES' ? 'default' : 'outline'}
                    disabled
                  >
                    Approve (YES)
                  </UiButton>
                  <UiButton
                    size='lg'
                    type='button'
                    variant={userVoteOption === 'NO' ? 'default' : 'outline2'}
                    disabled
                  >
                    Reject (NO)
                  </UiButton>
                </div>
              </div>
            )
          }

          return (
            <div className='flex flex-col gap-3 sm:flex-row'>
              <UiButton
                size='lg'
                type='button'
                variant='outline'
                disabled={isSubmitting}
                onClick={submitApprove}
              >
                Approve (YES)
              </UiButton>
              <UiButton
                size='lg'
                type='button'
                variant='outline2'
                disabled={isSubmitting}
                onClick={submitReject}
              >
                Reject (NO)
              </UiButton>
            </div>
          )
        })()}
      </UiCardContent>
    </UiCard>
  )
}
